import { render, staticRenderFns } from "./magic-link-expire.vue?vue&type=template&id=30dded50&scoped=true&"
import script from "./magic-link-expire.vue?vue&type=script&lang=js&"
export * from "./magic-link-expire.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30dded50",
  null
  
)

export default component.exports